import { useField } from "formik";
import { ReactNode } from "react";

import FormControlLabel from "@mui/material//FormControlLabel";
import CheckboxMui from "@mui/material/Checkbox";

interface ICheckBoxTypedProperties {
  color?: "primary" | "secondary";
  formControlSx?: object;
  isDisabled?: boolean;
  label: ReactNode | string;
  name: string;
  onChange?: (newCheckedState: boolean) => void;
  size?: "medium" | "small";
  sx?: object;
}

export default function CheckBox({
  color = "primary",
  formControlSx = {},
  isDisabled = false,
  label,
  name,
  onChange = () => {
    /* Do Nothing */
  },
  size = "medium",
  sx = {},
}: ICheckBoxTypedProperties) {
  const [field, , helpers] = useField(name);
  const { setValue } = helpers;

  const updateState = (newCheckedState: boolean) => {
    void setValue(newCheckedState);
    onChange(newCheckedState);
  };

  return (
    <FormControlLabel
      control={
        <CheckboxMui
          {...field}
          checked={field.value === undefined ? false : field.value}
          color={color}
          disabled={isDisabled}
          name={name}
          onChange={() => updateState(!field.value)}
          size={size}
          sx={{ ...sx }}
        />
      }
      label={label}
      sx={{ ...formControlSx }}
    />
  );
}
